import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import { mapActions } from 'vuex';
import utils from '@/utils';
import table from '@/mixins/crud-table.js';
export default {
  mixins: [table],
  components: {
    componentForm: function componentForm() {
      return import('./form');
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var page = h("d2-container", {
      "attrs": {
        "spacious": true
      }
    }, [h("d2-search-panel", {
      "slot": "header",
      "model": {
        value: _this.search.panel.active,
        callback: function callback($$v) {
          _this.$set(_this.search.panel, "active", $$v);
        }
      }
    }, [h("d2-bar", {
      "slot": "title"
    }, [h("d2-bar-space"), this.p('query') ? h("d2-bar-cell", [this.vNodePaginationMini]) : h("d2-bar-cell", [this.vNodeSearchPanelAlertNoPermissionQuery]), h("d2-bar-space"), h("d2-bar-cell", [h("el-button-group", [this.p('query') ? this.vNodeButtonSearch : null, this.vNodeButtonTableColumnsFilterTrigger])]), this.p('add') ? h("d2-bar-cell", [this.vNodeButtonCreate]) : null]), this.p('query') ? this.vNodeSearchForm : null]), this.vNodeTable, h("d2-bar", {
      "slot": "footer"
    }, [h("d2-bar-cell", [this.vNodePaginationFull]), h("d2-bar-space")]), h("component-form", {
      "ref": "form",
      "on": {
        "success": this.research
      }
    }), this.vNodeTableColumnsFilter]);
    return page;
  },
  data: function data() {
    return {
      api: {
        index: 'DEVICE_BILL_ALL',
        delete: 'DEVICE_BILL_DELETE'
      },
      permission: {
        query: '',
        add: '',
        edit: '',
        detail: '',
        remove: ''
      }
    };
  },
  computed: {
    // 配置项
    // 表格列
    // 建议的书写顺序 [prop] -> [label] -> [align] -> [minWidth][width] -> [fixed] -> [other] -> [render][formatter] -> [if][show]
    settingColumns: function settingColumns() {
      var _this2 = this;

      var h = this.$createElement;
      return [{
        prop: 'id',
        label: this.$t('id'),
        minWidth: '80px'
      }, {
        prop: 'device_number',
        label: this.$t('device_number'),
        minWidth: '140px'
      }, {
        prop: 'type',
        label: this.$t('type'),
        minWidth: '100px',
        render: function render(_ref) {
          var row = _ref.row;
          return h("d2-dict", {
            "attrs": {
              "name": "bill_type",
              "value": row.type
            }
          });
        }
      }, {
        prop: 'pic',
        label: this.$t('pic'),
        minWidth: '80px',
        render: function render(_ref2) {
          var row = _ref2.row;
          return row.type == 1 ? row.pic.indexOf('static') != -1 ? h("el-image", {
            "attrs": {
              "src": _this2.$env.VUE_APP_PIC + row.pic,
              "fit": "cover",
              "preview-src-list": [_this2.$env.VUE_APP_PIC + row.pic],
              "lazy": true
            },
            "style": "height: 28px; width: 28px; border-radius: 2px;"
          }, [h("div", {
            "slot": "error",
            "style": "height: 100%; width: 100%;",
            "attrs": {
              "flex": "main:center cross:center"
            }
          }, [h("i", {
            "class": "el-icon-picture-outline"
          })])]) : h("el-image", {
            "attrs": {
              "src": row.pic,
              "fit": "cover",
              "preview-src-list": [row.pic],
              "lazy": true
            },
            "style": "height: 28px; width: 28px; border-radius: 2px;"
          }, [h("div", {
            "slot": "error",
            "style": "height: 100%; width: 100%;",
            "attrs": {
              "flex": "main:center cross:center"
            }
          }, [h("i", {
            "attrs": {
              "className": "el-icon-picture-outline"
            }
          })])]) : row.type == 2 ? row.pic.indexOf('static') != -1 ? h("video", {
            "attrs": {
              "src": _this2.$env.VUE_APP_PIC + row.pic,
              "fit": "cover",
              "preview-src-list": [_this2.$env.VUE_APP_PIC + row.pic],
              "lazy": true,
              "controls": true
            },
            "style": "height: 28px; width: 28px; border-radius: 2px;"
          }, [h("div", {
            "slot": "error",
            "style": "height: 100%; width: 100%;",
            "attrs": {
              "flex": "main:center cross:center"
            }
          }, [h("i", {
            "class": "el-icon-picture-outline"
          })])]) : h("video", {
            "attrs": {
              "src": row.pic,
              "fit": "cover",
              "preview-src-list": [row.pic],
              "lazy": true,
              "controls": true
            },
            "style": "height: 28px; width: 28px; border-radius: 2px;"
          }, [h("div", {
            "slot": "error",
            "style": "height: 100%; width: 100%;",
            "attrs": {
              "flex": "main:center cross:center"
            }
          }, [h("i", {
            "attrs": {
              "className": "el-icon-picture-outline"
            }
          })])]) : row.type == 3 ? row.pic.indexOf('static') != -1 ? h("embed", {
            "attrs": {
              "src": _this2.$env.VUE_APP_PIC + row.pic,
              "fit": "cover",
              "preview-src-list": [_this2.$env.VUE_APP_PIC + row.pic],
              "lazy": true,
              "controls": true
            },
            "style": "height: 28px; width: 28px; border-radius: 2px;"
          }, [h("div", {
            "slot": "error",
            "style": "height: 100%; width: 100%;",
            "attrs": {
              "flex": "main:center cross:center"
            }
          }, [h("i", {
            "class": "el-icon-picture-outline"
          })])]) : h("embed", {
            "attrs": {
              "src": row.pic,
              "fit": "cover",
              "preview-src-list": [row.pic],
              "lazy": true,
              "controls": true
            },
            "style": "height: 28px; width: 28px; border-radius: 2px;"
          }, [h("div", {
            "slot": "error",
            "style": "height: 100%; width: 100%;",
            "attrs": {
              "flex": "main:center cross:center"
            }
          }, [h("i", {
            "attrs": {
              "className": "el-icon-picture-outline"
            }
          })])]) : row.pic.indexOf('static') != -1 ? h("el-image", {
            "attrs": {
              "src": _this2.$env.VUE_APP_PIC + row.pic,
              "fit": "cover",
              "preview-src-list": [_this2.$env.VUE_APP_PIC + row.pic],
              "lazy": true
            },
            "style": "height: 28px; width: 28px; border-radius: 2px;"
          }, [h("div", {
            "slot": "error",
            "style": "height: 100%; width: 100%;",
            "attrs": {
              "flex": "main:center cross:center"
            }
          }, [h("i", {
            "class": "el-icon-picture-outline"
          })])]) : h("el-image", {
            "attrs": {
              "src": row.pic,
              "fit": "cover",
              "preview-src-list": [row.pic],
              "lazy": true
            },
            "style": "height: 28px; width: 28px; border-radius: 2px;"
          }, [h("div", {
            "slot": "error",
            "style": "height: 100%; width: 100%;",
            "attrs": {
              "flex": "main:center cross:center"
            }
          }, [h("i", {
            "attrs": {
              "className": "el-icon-picture-outline"
            }
          })])]);
        }
      }, {
        prop: 'pic',
        label: this.$t('file_url'),
        minWidth: '240px'
      }, {
        prop: 'c_time',
        label: this.$t('c_time'),
        minWidth: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.c_time, 'YYYY/M/D HH:mm:ss');
        }
      }, {
        prop: 'u_time',
        label: this.$t('u_time'),
        minWidth: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.u_time, 'YYYY/M/D HH:mm:ss');
        }
      }].map(function (setting) {
        setting.sortable = 'custom';
        return setting;
      });
    },
    // 配置项
    // 表格操作列配置
    settingActionsConfig: function settingActionsConfig() {
      var _this3 = this;

      return function (_ref3) {
        var row = _ref3.row;
        return [].concat(_toConsumableArray(_this3.p('edit', [{
          icon: 'el-icon-edit-outline',
          action: function action() {
            return _this3.edit(row.id);
          }
        }], [])), _toConsumableArray(_this3.p('remove', [{
          icon: 'el-icon-delete',
          type: 'danger',
          confirm: _this3.$t('confirm_delete_info'),
          action: function action() {
            return _this3.delete(row.id);
          }
        }], [])));
      };
    },
    // 配置项
    // 表格搜索条件
    // 建议的书写顺序 [prop] -> [label] -> [default] -> [render] -> [if][show]
    settingSearch: function settingSearch() {
      var _this4 = this;

      var h = this.$createElement;
      return [{
        prop: 'device_number',
        label: this.$t('device_number'),
        default: this.device_number,
        render: function render() {
          return h("el-input", {
            "style": "width:120px;",
            "attrs": {
              "disabled": true
            },
            "model": {
              value: _this4.search.form.model.device_number,
              callback: function callback($$v) {
                _this4.$set(_this4.search.form.model, "device_number", $$v);
              }
            }
          });
        }
      }, {
        prop: 'type',
        label: this.$t('type'),
        default: '',
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "bill_type",
              "custom": true,
              "clearable": true
            },
            "style": "width:130px;",
            "model": {
              value: _this4.search.form.model.type,
              callback: function callback($$v) {
                _this4.$set(_this4.search.form.model, "type", $$v);
              }
            }
          });
        }
      }, {
        prop: 'start_time',
        label: this.$t('start_time'),
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "start_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this4.search.form.model.start_time,
              callback: function callback($$v) {
                _this4.$set(_this4.search.form.model, "start_time", $$v);
              }
            }
          });
        }
      }, {
        prop: 'end_time',
        label: this.$t('end_time'),
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "end_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this4.search.form.model.end_time,
              callback: function callback($$v) {
                _this4.$set(_this4.search.form.model, "end_time", $$v);
              }
            }
          });
        }
      }];
    },
    // [本页面特有] 父级字典项目的 id 强制转为数字
    device_number: function device_number() {
      return this.$route.query.device_number;
    }
  },
  methods: _objectSpread({}, mapActions('d2admin/page', ['closeBy']))
};